import React, { useEffect, useState } from 'react'
import { BiRightArrowAlt } from 'react-icons/bi'
import { GiHockey } from 'react-icons/gi'

import MainHeader from '../components/MainHeader'
import Loader from '../components/Loader'

import { getOtherTeamLine, getTeamBench } from '../redux/actions/depthChartAction'
import { useSelector } from 'react-redux'
import { MdLock } from 'react-icons/md'
import { useLocation, useParams } from 'react-router-dom'

const mockData = [
  {
    type: '',
    name: '',
    classKey: 'line1-1',
    Position: 'LW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'line1-2',
    Position: 'C',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    name: '',
    classKey: 'line1-3',
    Position: 'RW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'line2-1',
    Position: 'LW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'line2-2',
    Position: 'C',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    name: '',
    classKey: 'line2-3',
    Position: 'RW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'line3-1',
    Position: 'LW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'line3-2',
    Position: 'C',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    name: '',
    classKey: 'line3-3',
    Position: 'RW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'line4-1',
    Position: 'LW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'line4-2',
    Position: 'C',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Center',
  },
  {
    type: '',
    name: '',
    classKey: 'line4-3',
    Position: 'RW',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Winger',
  },
  {
    type: '',
    name: '',
    classKey: 'pairing1-1',
    Position: 'D',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    name: '',
    classKey: 'pairing1-2',
    Position: 'D',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    name: '',
    classKey: 'pairing2-1',
    Position: 'D',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    name: '',
    classKey: 'pairing2-2',
    Position: 'D',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    name: '',
    classKey: 'pairing3-1',
    Position: 'D',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    name: '',
    classKey: 'pairing3-2',
    Position: 'D',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
  {
    type: '',
    name: '',
    classKey: 'goalie',
    Position: 'G',
    imageUrl: require('../assets/goalie-player.jpeg'),
    positionName: 'Goalie',
  },
  {
    type: '',
    name: '',
    classKey: 'pairing4-1',
    Position: 'D',
    imageUrl: require('../assets/hockey-player.jpeg'),
    positionName: 'Defender',
  },
]

const TeamViewLineUp = () => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const [data, setData] = useState(mockData)
  const [benchData, setBenchData] = useState([])
  const [loading, setLoading] = useState(true)
  const [weekProjection, setWeekProjection] = useState('')

  const params = useParams()
  const { state } = useLocation()

  useEffect(() => {
    getData()
  }, [params?.id, SETTING.date])

  const getData = async () => {
    const filtered = [...mockData]
    setLoading(true)
    const payload = { date: SETTING?.date, team: params?.id }
    const res = await getOtherTeamLine(payload)
    if (res) {
      setWeekProjection(res?.weekProjection)
      if (res?.data?.length > 0) {
        res?.data.map((item) => {
          let index = filtered.findIndex((item2) => {
            return item2.classKey === item.classKey
          })
          if (index !== -1) {
            filtered.splice(index, 1, {
              imageUrl:
                item?.player?.player_id?.HostedHeadshotNoBackgroundUrl || filtered[index].imageUrl,
              Name: item?.player?.player_id?.Name,
              Position: filtered[index].Position,
              positionName: filtered[index].positionName,
              classKey: filtered[index].classKey,
              type: filtered[index].type,
              isPlayerLocked: item?.player?.isPlayerLocked ? item?.player?.isPlayerLocked : false,
            })
          }
        })
        setData([...filtered])
      } else {
        setData([...filtered])
      }
      const response = await getTeamBench(payload)
      if (response) {
        setBenchData(response)
      }
    }
    setLoading(false)
  }

  const TimelineCard = ({ data }) => {
    const { Name, imageUrl, positionName, isPlayerLocked } = data

    // const handleCard = () => {
    //   const check = () => {
    //     if (isLocked()) return false
    //     if (isPlayerLocked) return false
    //     if (!isPlayerLocked) return true
    //   }

    //   if (check()) {
    //     setOpenModal(true)
    //     setModalData(data)
    //   }
    // }

    return (
      <>
        <div
          className='timeline_card'
          // onClick={handleCard}
          style={{ cursor: 'no-drop' }}
        >
          {isPlayerLocked && (
            <div className={`timeline_card_locked`}>
              <MdLock size={50} color={'#fff'} />
            </div>
          )}
          <div className='text_box' style={{ borderRadius: '10px 10px 0px 0px' }}>
            <h4>{positionName}</h4>
          </div>
          <div className='image_box'>
            {imageUrl ? (
              <img src={imageUrl} alt='Picture' />
            ) : (
              <div className='hockey_icon_box'>
                <GiHockey size={50} />
              </div>
            )}
          </div>
          <div className='text_box' style={{ borderRadius: '0px 0px 10px 10px' }}>
            <p>{Name}</p>
          </div>
        </div>
      </>
    )
  }

  const Line = ({ number, text }) => {
    return (
      <div className='timeline_card_line'>
        <p>{number}</p>
        <p>{text}</p>
      </div>
    )
  }

  return (
    <div className='time_line_container'>
      <MainHeader />

      <div className='viewing_roster_heading'>
        <h2>Your are viewing {state?.teamName || data[0]?.Team} line up.</h2>
      </div>

      <section className='body_wrapper'>
        <div className='body_content' style={{ position: 'relative' }}>
          {loading ? (
            <Loader />
          ) : (
            <>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
                <div className='body_content_left'>
                  <div className='card_01'>
                    <p>Total</p>
                    <p>Week Proj</p>
                    <h2>{weekProjection || '-'}</h2>
                  </div>
                </div>
                <div className='body_content_center'>
                  <div className='timeline_row'>
                    {data?.slice(0, 3)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                    <Line number={'1st'} text={'Line'} />
                  </div>
                  <div className='timeline_row'>
                    {data?.slice(3, 6)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                    <Line number={'2nd'} text={'Line'} />
                  </div>
                  <div className='timeline_row'>
                    {data?.slice(6, 9)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                    <Line number={'3rd'} text={'Line'} />
                  </div>
                  <div className='timeline_row'>
                    {data?.slice(9, 12)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                    <Line number={'4th'} text={'Line'} />
                  </div>
                </div>
                <div className='body_content_right'>
                  <div className='timeline_row'>
                    <Line number={'1st'} text={'Pairing'} />
                    {data?.slice(12, 14)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                  </div>
                  <div className='timeline_row'>
                    <Line number={'2nd'} text={'Pairing'} />
                    {data?.slice(14, 16)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                  </div>
                  <div className='timeline_row'>
                    <Line number={'3rd'} text={'Pairing'} />
                    {data?.slice(16, 18)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                  </div>
                  <div className='timeline_row'>
                    <Line number={''} text={''} />
                    {data?.slice(18, 20)?.map((v) => {
                      return <TimelineCard key={v?.classKey} data={v} />
                    })}
                  </div>
                </div>
              </div>
              <div className='bench_player_container'>
                <div className='bench_player_box'>
                  <header>
                    <h3>Team Bench</h3>
                    <p>
                      View All <BiRightArrowAlt size={18} />
                    </p>
                  </header>
                  <section className='bench_player_body'>
                    {benchData?.map((v, i) => {
                      return (
                        <div key={i} className='bench_player_card'>
                          <div className='left'>
                            {v?.player_id?.HostedHeadshotNoBackgroundUrl ? (
                              <img src={v?.player_id?.HostedHeadshotNoBackgroundUrl} />
                            ) : (
                              <GiHockey size={50} color={'#fff'} />
                            )}
                          </div>
                          <div className='center'>
                            <div>
                              <p className='text1'>Team</p>
                              <p className='text2'>{v?.player_id?.Team || '-'}</p>
                            </div>
                            <div>
                              <p className='text1'>Pos</p>
                              <p className='text2'>{v?.player_id?.Position || '-'}</p>
                            </div>
                            <div>
                              <p className='text1'>Player</p>
                              <p className='text2'>{v?.player_id?.Name || '-'}</p>
                            </div>
                            <div>
                              <p className='text1'>Status</p>
                              <p className='text2'>{v?.player_id?.InjuryStatus || '-'}</p>
                            </div>
                            <div>
                              <p className='last_text'>
                                Opponent & <br /> Gametime
                              </p>
                              <p className='text2'>{v?.player_id?.Opponent || '-'}</p>
                            </div>
                          </div>
                          <div className='right'>
                            <p>Week</p>
                            <p>Projections</p>
                            <h4>{v?.player_id?.Projection || '-'}</h4>
                          </div>
                        </div>
                      )
                    })}
                  </section>
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  )
}

export default TeamViewLineUp
